import React, { Component } from 'react';
import { isAuthenticated } from '../auth';
import { create } from './apiPost';
import { Redirect } from 'react-router-dom';
import LoadingAnim from '../core/LoadingAnim';
import DefaultPhoto from '../assets/default-post.jpg';

class NewPost extends Component {
    constructor() {
        super();
        this.state = {
            title: '',
            body: '',
            photo: '',
            error: '',
            user: {},
            fileSize: 0,
            loading: false,
            redirectToProfile: false
        }
    }

    componentDidMount() {
        this.postData = new FormData();
        //console.log('postData:', this.postData);
        this.setState({ user: isAuthenticated().user });
    }

    isValid = () => {
        const { title, body, fileSize } = this.state;

        if (fileSize > 1000000) {
            this.setState({ error: "Fils size must be less than 1MB.", loading: false });
            return false;
        }

        if (title.length === 0 || body.length === 0) {
            this.setState({ error: "Please fill in all the fields.", loading: false });
            return false;
        }

        return true;
    };

    handleChange = name => event => {
        this.setState({ error: "" });
        const value = name === "photo" ? event.target.files[0] : event.target.value;
        const fileSize = name === "photo" ? event.target.files[0].size : 0;
        this.postData.set(name, value);
        this.setState({ [name]: value, fileSize });
        //console.log('postData:', this.postData);
        // update the image using FileReader //
        
        if (name === "photo") {
            const lReader = new FileReader();
            lReader.onload = function (e) {
                document.getElementById('post_photo').setAttribute('src', e.target.result);
            }
            lReader.readAsDataURL(event.target.files[0]);
        }
    }

    clickSubmit = event => {
        event.preventDefault();

        if (this.isValid()) {
            this.setState({ loading: true });

            const userId = isAuthenticated().user._id;
            const token = isAuthenticated().token;
            create(userId, token, this.postData).then(data => {
                if (data.error) {
                    this.setState({ error: data.error });
                } else {
                    console.log('clickSubmit New Post:', data);
                    this.setState({loading: false, title: '', body: '', photo: '', redirectToProfile: true});
                }
            })
        }
    }

    newPostForm = (title, body, photo) => (
        <form>
            <div className="form-group">
                <label className="text-muted">Post Photo</label>
                <input onChange={this.handleChange("photo")} type="file" accept="image/*" className="form-control" />
            </div>
            <div className="form-group">
                <label className="text-muted">Post Title</label>
                <input onChange={this.handleChange("title")} type="text" className="form-control" value={title} />
            </div>
            <div className="form-group">
                <label className="text-muted">Post</label>
                <textarea onChange={this.handleChange("body")} type="text" className="form-control" value={body} />
            </div>
            <button onClick={this.clickSubmit} className="btn btn-raised btn-success">Create Post</button>
        </form>
    )

    render() {
        const { title, body, user, loading, error, photo, redirectToProfile } = this.state;
        if (redirectToProfile) {
            return <Redirect to={`/user/${user._id}`} />
        }

        //const lDate = Date.now();
        //const photoUrl = id ? `${process.env.REACT_APP_API_URL}/user/photo/${id}?v=${lDate}` : DefaultProfile;

        return (
            <div className="container">
                <h2 className="mt-5">Create Post</h2>
                {loading ? <LoadingAnim /> : <img
                    id="post_photo"
                    src={DefaultPhoto}
                    className="img-thumbnail img-fluid"
                    style={{ width: 'auto', maxHeight: '400px', margin: 'auto' }}
                    //style={{ width: 400, height: 250, margin: 'auto' }}
                    alt={user.name}
                />}
                {!loading ? this.newPostForm(title, body, photo) : null}
                <div className="alert alert-danger" style={{ visibility: error ? "visible" : "hidden" }}>
                    {error}
                </div>

            </div>
        )
    }
}

export default NewPost;